import { createAction } from '@reduxjs/toolkit';
export const FETCH_ANALYTIC_DOMAIN_USERS_USAGE_SNAPSHOT = 'FETCH_ANALYTIC_DOMAIN_USERS_USAGE_SNAPSHOT';
export const fetchAnalyticDomainUsersUsageSnapshotAction = createAction(FETCH_ANALYTIC_DOMAIN_USERS_USAGE_SNAPSHOT);